<template>
    <v-container grid-list-md text-center>
        <v-toolbar dense dark elevation="0">
            <v-toolbar-title>My Reports</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

            </v-toolbar-items>
            <template v-slot:extension>                
                <v-tabs
                    v-model="tab"
                    slider-color="primary"
                    background-color="transparent"
                >
                    <v-tab
                        v-for="type in types.map(x=>x.name)"
                        :key="type"
                    >
                        {{ type }}
                    </v-tab>
                    </v-tabs>
                </template>
        </v-toolbar>
    
        <v-card outlined>
            <v-toolbar flat color="white">
                <v-toolbar-title class="caption">{{ count }} {{count == 1? "candidate" : "candidates"}} reported</v-toolbar-title>
            </v-toolbar>
            <v-data-table
                :headers="headers"
                :items="reports"
                :loading="loading"
                :sort-by="['date']"
                :sort-desc="[true]"
                hide-default-footer
            >
                <template v-slot:item.solved="{ item }">{{ item.solved ? "Solved" : "Not solved" }}</template>
                <template v-slot:item.action="{ item }">
                    <v-btn class="ma-2" outlined small color="red" @click="openDelete(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <div class="text-center pt-2">
                <v-pagination
                    v-model="currentPage"
                    :length="pageCount"
                    :total-visible="10"
                    circle>
                </v-pagination>
            </div>
        </v-card>
        <v-dialog v-model="deleteDialog" persistent max-width="700">
            <delete-report :candidate.sync="selected" :show.sync="deleteDialog"></delete-report>
        </v-dialog>
    </v-container>
</template>
<script>
import DeleteReport from "@/components/dialogs/DeleteReport.vue"
import { formatReports } from "../components/utils/report.js";
export default {
    name: "MyReports",
    data() {
        return {
            headers: [
                { value: "object", text: "Object" },
                //{ value: "report_type", text: "Type" },
                { value: "date", text: "Date" },
                //{ value: "observation", text: "Observation" },
                { value: "solved", text: "Status" },
                { value: "source", text: "Source" },
                { value: "action", text: "Action" }
            ],
            deleteDialog: false,
            selected: {},
            reports: [],
            currentPage: 1,
            itemsPerPage: 10,
            loading: true,
            count: 0,
            tab: 0,
            types: [
                {
                    name: "Bogus",
                    value: "Bogus"
                },
                {
                    name: "TOM Candidates",
                    value: "TOM"
                }
            ]
        };
    },
    components: {
        DeleteReport
    },
    mounted() {
        this.getReportsPage(this.currentPage, this.itemsPerPage, this.types[this.tab].value);
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
        types_arr() {
            return this.types.map(x => x.name)
        }
        ,
        pageCount: {
            get() {
                return Math.ceil(this.count / this.itemsPerPage);
            }
        }
    },
    methods: {
        openDelete(item) {
            this.selected = item;
            this.deleteDialog = true;
        },
        getReportsPage(page, itemsPerPage, report_type) {
            this.$api.getReportsByUser(page, itemsPerPage, report_type).then(response => {
                this.reports = formatReports(response.data.results);
                this.nextPage = response.data.next;
                this.prevPage = response.data.previous;
                this.count = response.data.count;
                this.loading = false;
            });
        },
        clearPage() {
            this.reports = [];
            this.count = 0;
            this.currentPage = 1;
        }
    },
    watch: {
        tab(newVal) {
            this.clearPage();
            this.getReportsPage(null, this.itemsPerPage, this.types[newVal].value)
        },
        currentPage(newVal) {
            this.getReportsPage(newVal, this.itemsPerPage, this.types[newVal].value)
        },
        selected(){
            this.getReportsPage(this.currentPage, this.itemsPerPage, this.types[this.tab].value);
        }
    }
};
</script>
